export default {
    namespaced: true,
    state: {
        isDismissed: false,
        dismissedDate: null,
        dateFrom: null,
        dateTo: null,
        status: null
    },
    mutations: {
        SET_DISMISSED(state, date) {
            state.isDismissed = true;
            state.dismissedDate = date;
        },
        RESET_DISMISSED(state) {
            state.isDismissed = false;
            state.dismissedDate = null;
        },
        SET_DATE_RANGE(state, { dateFrom, dateTo }) {
            state.dateFrom = dateFrom;
            state.dateTo = dateTo;
        },
        SET_STATUS(state, status) {
            state.status = status;
        }
    },
    actions: {
        dismissNotification({ commit }) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            commit('SET_DISMISSED', today.toISOString());
        },
        checkDismissalStatus({ commit, state }, { dateFrom, dateTo, status } = {}) {
            if (
                dateFrom !== state.dateFrom ||
                dateTo !== state.dateTo ||
                status !== state.status
            ) {
                commit('RESET_DISMISSED');
                commit('SET_DATE_RANGE', { dateFrom, dateTo });
                commit('SET_STATUS', status);
                return;
            }

            if (state.dismissedDate) {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const dismissedDate = new Date(state.dismissedDate);
                if (today.toISOString() !== dismissedDate.toISOString()) {
                    commit('RESET_DISMISSED');
                }
            }
        }
    }
};
